import { call, select } from "redux-saga/effects";

import {
  getShopItemByID,
  getShopItemIDList
} from "state/school_money/selectors";

import BasketItemIssue from "state/school_money/entities/BasketItemIssue";

/**
 * Check for issues with the given basket item.
 * Returns zero or one issues.
 *
 * @param {BasketItem} basketItem
 * @returns {BasketItemIssue | undefined}
 */
export default function* validateBasketItem(basketItem) {

  const shopItemID = basketItem.payload.get("shopItemID");

  if (yield call(isExpired, shopItemID)) {
    return BasketItemIssue.fromBasketItem(basketItem, "expired");
  }

  const shopItem = yield select(getShopItemByID, shopItemID);

  if (isOutOfStock(shopItem)) {
    return BasketItemIssue.fromBasketItem(basketItem, "out_of_stock");
  }

  if (hasInsufficientStock(basketItem, shopItem)) {
    return BasketItemIssue.fromBasketItem(basketItem, "insufficient_stock");
  }

}

/**
 * Has the shop item disappeared from state?
 * @returns {boolean}
 */
function* isExpired(shopItemID) {
  const shopItemIDList = yield select(getShopItemIDList);
  return !shopItemIDList.includes(shopItemID);
}

/**
 * Has this shop item gone out of stock?
 * @returns {boolean}
 */
function isOutOfStock(shopItem) {
  return shopItem.get("quantity") === 0;
}

/**
 * Does this shop item have less stock than the user has added to their basket?
 * @returns {boolean}
 */
function hasInsufficientStock(basketItem, shopItem) {
  return shopItem.get("quantity") < basketItem.payload.get("quantity");
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/basketSaga/shopItem/validateBasketItem.js